import React, { useState } from "react";
import SearchBar from "../../../components/header/search-bar/SearchBar";
import { useNavigate, useSearchParams } from "react-router-dom";
import useApiService from "../../../hooks/useApiService";
import { getSellerProfileByToken } from "../../../services/main-service/mainService";
import { AD_SETTINGS_PAGE_AD_LIMIT } from "../../../configs/limits/adLimits";
import Spinner from "../../../components/common/spinner/Spinner";
import AdSettingRow from "../../../components/main-layout-components/ad-setting-card/ad-setting-row/AdSettingRow";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "../../../styles/css/data-table.css";

function AdSettingsPage() {
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  let page = searchParams.get("page") || "1";
  let searchTerm = searchParams.get("searchTerm") || "";
  let [adDeleted, setAdDeleted] = useState<boolean>(false);

  const handleSearch = (query: string) => {
    setSearchParams((prevSearchParams) => {
      const newParams = new URLSearchParams(prevSearchParams);
      newParams.set("searchTerm", query);
      newParams.set("page", "1");
      return newParams;
    });
  };

  const payload = {
    limit: AD_SETTINGS_PAGE_AD_LIMIT,
    skip: 0 + (Number(page) - 1) * AD_SETTINGS_PAGE_AD_LIMIT,
    category: "",
    hidden: "n/a",
    location: "",
    search_term: searchTerm,
  };

  const { data, loading, error } = useApiService({
    serviceCall: () => getSellerProfileByToken(payload),
    dependencies: [page, searchTerm, adDeleted],
  });

  function handleNextBtn() {
    setSearchParams({ page: (Number(page) + 1).toString(), searchTerm });
  }

  function handlePreviousBtn() {
    if (Number(page) - 1 > 0) {
      setSearchParams({ page: (Number(page) - 1).toString(), searchTerm });
    }
  }

  if (loading) return <Spinner />;
  if (error) return <p className="text-center mt-5">{error}</p>;

  return (
    <div className="data-page">
      <div className="container">
        <div className="data-page__card">
          {/* Header */}
          <div className="data-page__header">
            <div>
              <h4 className="data-page__title">My Ads</h4>
              <p className="data-page__subtitle">
                {data?.profile?.name
                  ? `Listings for ${data.profile.name}`
                  : "Manage your listings"}
              </p>
            </div>
            <div className="data-page__search-wrap">
              <SearchBar placeholder="Search your ads…" onSearch={handleSearch} />
            </div>
          </div>

          {/* Table */}
          <div className="data-table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Ad</th>
                  <th>Approval</th>
                  <th>Approved Date</th>
                  <th>Boost Type</th>
                  <th>Boost Status</th>
                  <th>Boost End</th>
                  <th>Actions</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {!data?.classifieds?.length ? (
                  <tr>
                    <td colSpan={8} className="data-table-empty">
                      No ads found
                    </td>
                  </tr>
                ) : (
                  data.classifieds.map((classified) => (
                    <AdSettingRow key={classified.id} adDetails={classified} />
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="data-page__pagination">
            <button
              className="data-page__nav-btn"
              disabled={Number(page) === 1}
              onClick={handlePreviousBtn}
            >
              <FaChevronLeft size={11} /> Previous
            </button>
            <span className="data-page__page-info">Page {page}</span>
            <button
              className="data-page__nav-btn"
              disabled={data?.is_last_page}
              onClick={handleNextBtn}
            >
              Next <FaChevronRight size={11} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdSettingsPage;
